import { render, staticRenderFns } from "./resultSignature.vue?vue&type=template&id=197b95f9&"
import script from "./resultSignature.vue?vue&type=script&lang=js&"
export * from "./resultSignature.vue?vue&type=script&lang=js&"
import style0 from "./resultSignature.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports